import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import Grid, { GridSpacing } from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import LoadingButton from '@mui/lab/LoadingButton';

import { SIG_CMP_GROUP_SET } from '../../../function/GroupDataModel';
import RawWaveformComparisonChart, { GraphDispSetting } from './RawWaveformComparisonChart';
import RawWaveformComparisonSelectItem from './RawWaveformComparisonSelectItem';
import RawWaveformComparisonChartSetting from './RawWaveformComparisonChartSetting';
import RawWaveformComparisonButtonList from './RawWaveformComparisonButtonList';
import {
  MeasureInfoType,
  GetMeasureInfoType,
  SelectDataType,
  GetLatesTime,
  GetDataTimeList,
} from './RawWaveformComparison';
import SearchIcon from '@material-ui/icons/Search';
import { useTranslation } from 'react-i18next';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(
  createStyles({
    responsiveContainer: {
      minHeight: 'calc(100vh - 442px)',
      maxHeight: 'calc(100vh - 442px)',
    },
    paper: {
      background: '#FFFFEE',
    },
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },
  })
);

const CreateSelectData = (meslist: MeasureInfoType[], target?: MeasureInfoType): SelectDataType => {
  var ret: SelectDataType = {
    devid: -1,
    mesid: -1,
    itemid: -1,
    selectDate: new Date(),
    selectTime: '',
    isSelect: false,
    isShow: true,
    isLowPassFlg:false,
    isLowPassNo:0,
  };

  if (target == undefined) {
    return ret;
  } else {
    var mid = meslist.find(
      (row) => (row.Speed === 2 || row.Speed === 4) && row.KindNo == target.KindNo && row.MesName == target.MesName
    );
    ret.mesid = mid != undefined ? mid.id : ret.mesid;

    var did = meslist.find((row) => (row.Speed === 2 || row.Speed === 4) && row.DevIndex == target.DevIndex);
    ret.devid = did != undefined ? did.id : ret.devid;

    var iid = meslist.find(
      (row) =>
        (row.Speed === 2 || row.Speed === 4) &&
        row.KindNo === target.KindNo &&
        row.DevIndex === target.DevIndex &&
        row.ItemNameNo == target.ItemNameNo &&
        row.ItemName == target.ItemName
    );
    ret.itemid = iid != undefined ? iid.id : ret.itemid;

    return ret;
  }
};

type Props = {
  location: { state: SIG_CMP_GROUP_SET };
};

const RawWaveformComparisonPage: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [chartUpdate, setChartUpdate] = React.useState<string>('');
  const [measureInfo, setMeasereInfo] = React.useState<MeasureInfoType[]>([]);
  const [isLineShows, setIsLineShow] = React.useState<boolean[]>([true, true]);
  const [selectData1, setSelectData1] = React.useState<SelectDataType>({
    devid: 1,
    mesid: 1,
    itemid: 1,
    selectDate: new Date(),
    selectTime: '',
    isSelect: false,
    isShow: true,
    isLowPassFlg:false,
    isLowPassNo:0,
  });
  const [selectData2, setSelectData2] = React.useState<SelectDataType>({
    devid: 1,
    mesid: 1,
    itemid: 1,
    selectDate: new Date(),
    selectTime: '',
    isSelect: false,
    isShow: true,
    isLowPassFlg:false,
    isLowPassNo:0,
  });
  const [graphDispSetting, SetGraphDispSetting] = React.useState<GraphDispSetting>({
    xMin: 0,
    xMax: 100,
    y1Min: -0.02,
    y1Max: 0.02,
    y2Min: -0.02,
    y2Max: 0.02,
    isPileup: false,
    isDCRemoval: true,
  });
  const isAutoRangeRef = React.useRef<boolean>(true);

  useEffect(() => {
    setLoading(true);
    GetMeasureInfoType().then((mesRet) => {
      //生波形画面では不要な項目を排除
      mesRet = mesRet.filter((r) => r.FftInvalid === 0);

      for (var i in mesRet) {
        mesRet[i].id = Number(i + 1);
      }

      var s1: SelectDataType = {
        devid: 1,
        mesid: 1,
        itemid: 1,
        selectDate: new Date(),
        selectTime: '',
        isSelect: false,
        isShow: true,
        isLowPassFlg:false,
        isLowPassNo:0,
      };
      var s2: SelectDataType = {
        devid: 1,
        mesid: 1,
        itemid: 1,
        selectDate: new Date(),
        selectTime: '',
        isSelect: false,
        isShow: true,
        isLowPassFlg:false,
        isLowPassNo:0,
      };

      if (props.location.state != null) {
        var gp = props.location.state;
        var dt1 = mesRet.find((item) => item.PlcNo == gp.PLC_NO1 && item.SetNo == gp.SET_NO1);
        var dt2 = mesRet.find((item) => item.PlcNo == gp.PLC_NO2 && item.SetNo == gp.SET_NO2);

        if (gp.Time_No1 !== undefined) {
          console.debug(['reseve SIG_CMP_GROUP_SET', gp, gp.Time_No1]);
          s1 = CreateSelectData(mesRet, dt1);
          s1.selectDate = gp.Time_No1 == '' ? new Date() : dayjs(gp.Time_No1).toDate();
          s1.selectTime = '';
          s1.isLowPassFlg = selectData1.isLowPassNo === 1;

          s2 = CreateSelectData(mesRet, dt2);
          s2.selectDate = gp.Time_No2 == '' ? new Date() : dayjs(gp.Time_No2).toDate();
          s2.selectTime = '';
          s2.isLowPassFlg = selectData2.isLowPassNo === 1;

          var c = GetDataTimeList(
            Number(dt1?.PlcNo),
            Number(dt1?.AiCard),
            Number(dt1?.AiCh),
            dayjs(s1.selectDate).format('YYYY-MM-DD'),
            s1.isLowPassFlg
          );
          var d = GetDataTimeList(
            Number(dt2?.PlcNo),
            Number(dt2?.AiCard),
            Number(dt2?.AiCh),
            dayjs(s2.selectDate).format('YYYY-MM-DD'),
            s2.isLowPassFlg
          );
          Promise.all([c, d]).then((ret) => {
            if (ret) {
              if (ret[0] && ret[0][0]) {
                s1.selectTime = dayjs(ret[0][0]).format('HH:mm:ss');
              }
              if (ret[1] && ret[1][0]) {
                s2.selectTime = dayjs(ret[1][0]).format('HH:mm:ss');
              }
            }

            console.debug(['-RawWaveformComparisonPage line1 sData1', dt1, s1]);
            console.debug(['-RawWaveformComparisonPage line2 sData1', dt2, s2]);
            setSelectData1(prev => ({
                            ...s1,
                            isLowPassFlg: prev.isLowPassNo ===1,
                          }));
            setSelectData2(prev => ({
                            ...s2,
                            isLowPassFlg: prev.isLowPassNo ===1,
                          }));
            setMeasereInfo(mesRet);
            setChartUpdate('start');
            setLoading(true);
          });
        } else {
          var a = GetLatesTime(dt1?.PlcNo, dt1?.AiCard, dt1?.AiCh);
          var b = GetLatesTime(dt2?.PlcNo, dt2?.AiCard, dt2?.AiCh);
          Promise.all([a, b]).then((ret) => {
            s1 = CreateSelectData(mesRet, dt1);
            if (dayjs(new Date(ret[0])).format('YYYY-MM-DD') == '1-01-01') {
              s1.selectDate = new Date();
              s1.selectTime = '';
            } else {
              s1.selectDate = new Date(ret[0]);
              s1.selectTime = dayjs(new Date(ret[0])).format('HH:mm:ss');
            }

            s2 = CreateSelectData(mesRet, dt2);
            if (dayjs(new Date(ret[1])).format('YYYY-MM-DD') == '1-01-01') {
              s2.selectDate = new Date();
              s2.selectTime = '';
            } else {
              s2.selectDate = new Date(ret[1]);
              s2.selectTime = dayjs(new Date(ret[1])).format('HH:mm:ss');
            }

            console.debug(['-RawWaveformComparisonPage line1 sData2', dt1, s1]);
            console.debug(['-RawWaveformComparisonPage line2 sData2', dt2, s2]);

            setSelectData1({ ...s1 });
            setSelectData2({ ...s2 });
            setMeasereInfo(mesRet);
            setChartUpdate('start');
            setLoading(true);
          });
        }
      } else {
        setSelectData1({ ...s1 });
        setSelectData2({ ...s2 });
        setMeasereInfo(mesRet);
      }
    });
  }, []);

  const handleLoadingStateChange = (value: boolean): void => setLoading(value);

  const handleisShowSelectChange1 = (value: SelectDataType) => {
    setIsLineShow([value.isShow, isLineShows[1]]);
    setSelectData1({ ...value });
  };
  const handleisShowSelectChange2 = (value: SelectDataType) => {
    setIsLineShow([isLineShows[0], value.isShow]);
    setSelectData2({ ...value });
  };

  const handleonSelectData1Change = (value: SelectDataType) => {
    console.debug(['test data',value])
    setSelectData1(prev => ({
    ...prev,
    ...value,
    isLowPassFlg: value.isLowPassNo === 1,
    isLowPassNo: value.isLowPassNo
  }));
  };
  const handleonSelectData2Change = (value: SelectDataType) => {
    setSelectData2(prev => ({
    ...prev,
    ...value,
    isLowPassFlg: value.isLowPassNo === 1, 
    isLowPassNo: value.isLowPassNo
  }));
  };
  const handleChartUpdate = () => {
    setSelectData1(prev => ({ ...prev }));
    setSelectData2(prev => ({ ...prev }));

    setChartUpdate(dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'));
  };

  const handleGraphSettingChange = (data: GraphDispSetting) => {
    SetGraphDispSetting({ ...data });
  };
  const handleYMinMaxChange = (min1: number, max1: number, min2: number, max2: number) => {
    SetGraphDispSetting({ ...graphDispSetting, y1Min: min1, y1Max: max1, y2Min: min2, y2Max: max2 });
  };

  const handleLoading = (isFlg: boolean) => {
    setLoading(isFlg);
  };
  const handoleAutoRangeSet = (data: boolean) => {
    isAutoRangeRef.current = data;
  };

  return (
    <div>
      <Box display="flex" justifyContent="flex-start" alignItems="flex-end">
        <div style={{ width: 10 }}></div>{' '}
        <div style={{ width: 400 }}>
          <Paper>
            <RawWaveformComparisonSelectItem
              itemName={t('RawWaveformComparisonPage.計測データ１', '計測データ１')}
              onChangeSelectDataEvent={handleonSelectData1Change}
              onChnageIsShowSelect={handleisShowSelectChange1}
              itemColor="red"
              selectData={selectData1}
              mesInfoList={measureInfo}
              isBlankSelect={false}
              onAutoRangeSet={handoleAutoRangeSet}
            />
          </Paper>
        </div>{' '}
        <div style={{ width: 10 }}></div>
        <div style={{ width:  400  }}>
          <Paper>
            <RawWaveformComparisonSelectItem
              itemName={t('RawWaveformComparisonPage.計測データ２', '計測データ２')}
              onChangeSelectDataEvent={handleonSelectData2Change}
              onChnageIsShowSelect={handleisShowSelectChange2}
              itemColor="blue"
              selectData={selectData2}
              mesInfoList={measureInfo}
              isBlankSelect={true}
              onAutoRangeSet={handoleAutoRangeSet}
            />
          </Paper>
        </div>
        <div style={{ width: 10 }}></div>
        <div style={{ width: 100 }}>
          <LoadingButton
            style={{ width: '100px' }}
            loading={loading}
            loadingPosition="start"
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={handleChartUpdate}
          >
            {t('RawWaveformComparisonPage.表示', '表示　')}
          </LoadingButton>
        </div>
        <div style={{ width: 10 }}></div>
        <RawWaveformComparisonChartSetting settingData={graphDispSetting} onChange={handleGraphSettingChange} />
      </Box>
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="flex-end" style={{ margin: 0 }}>
        <Grid item xs={12}>
          <RawWaveformComparisonChart
            onChagneYMinMax={handleYMinMaxChange}
            chartContainerStyle={classes.responsiveContainer}
            graphDispSetting={graphDispSetting}
            line1={selectData1}
            line2={selectData2}
            mesList={measureInfo}
            update={chartUpdate}
            isLineShows={isLineShows}
            onLoading={handleLoading}
            isAutoRangeRef={isAutoRangeRef.current}
            onAutoRangeSet={handoleAutoRangeSet}
          />
        </Grid>
        <Grid item xs={12}>
          <RawWaveformComparisonButtonList
            measureInfo={measureInfo}
            selectDatas={[selectData1, selectData2]}
          ></RawWaveformComparisonButtonList>
        </Grid>
      </Grid>
    </div>
  );
};

export default RawWaveformComparisonPage;
